import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAdminAxiosInstance } from "../../../../api/Admin";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  isEdit: false,
  showCreateModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedId: "",
  showPassword: false,
  officeDeliveryData: {},
  editOfficeDeliveryData: {},
  error: "",
  statusData: {},
  isLoading: false,
};

export const getOfficeDeliveryEditData = createAsyncThunk(
  "/office-delivery/edit",
  async (id, { rejectWithValue }) => {
    const api = await getAdminAxiosInstance();
    try {
      const response = await api.get(`/office-delivery/edit?id=${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const officeDeliverySlice = createSlice({
  name: "officeDelivery",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOfficeDeliveryEditData.pending, (state, action) => {
        // state.isLoading = true;
      })
      .addCase(getOfficeDeliveryEditData.fulfilled, (state, action) => {
        state.editOfficeDeliveryData = action.payload?.data;
        // state.isLoading = false;
      })
      .addCase(getOfficeDeliveryEditData.rejected, (state, action) => {
        // state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { updateConfig } = officeDeliverySlice.actions;
export default officeDeliverySlice.reducer;
